import { Pipe, PipeTransform } from 'angular-ts-decorators';

import {
  IStartEndRenamedStrings,
  RelativeDateObject,
  RelativeTwoPartDateObject,
} from '@core/app/scripts/services/relative-date';
import { range } from 'lodash';
import { Moment } from '@shared/app/scripts/vendor/moment';

export type StartEndSummaryFilter = (input: IStartEndRenamedStrings) => string;

interface IStartEndSummary {
  transform: StartEndSummaryFilter;
}

/**
 * Take IStartEndStrings objects, and makes a human friendly string out of it
 * @param {IStartEndStrings} input
 * @return {string} Translation of absolute date OR '<start> - <end>'
 */
@Pipe({ name: 'startEndSummary' })
export class StartEndSummaryPipe implements PipeTransform, IStartEndSummary {
  constructor(
    private $translate: ng.translate.ITranslateService,
    private moment: Moment,
  ) {
    'ngInject';
  }

  public transform(input: IStartEndRenamedStrings): string {
    if (!angular.isObject(input) || !angular.isString(input.start)) {
      return this.$translate.instant('core.relative_dates.missing_input');
    }

    if (input.start in RelativeTwoPartDateObject) {
      if (input.start === 'month') {
        const months = range(-1, 11).map((value) => {
          return this.moment().month(value.toString()).format('MMMM');
        });

        return (
          this.$translate.instant('core.relative_dates.month') +
          ` ${months[input.end]}`
        );
      }
      let key = input.start.replace(/-/g, '_');

      // we assume the translation keys are mentioned literally in other place,
      // and therefore already covered by i18n script
      return (
        this.$translate.instant(`core.relative_dates.${key}`) + ` ${input.end}`
      );
    }

    if (input.start in RelativeDateObject) {
      let key = input.start.replace(/-/g, '_');

      // we assume the translation keys are mentioned literally in other place,
      // and therefore already covered by i18n script
      return this.$translate.instant(`core.relative_dates.${key}`);
    }

    // note! we use en dash below, be careful not to replace with minus
    return `${input.start} – ${input.end}`;
  }
}
